module.exports = __webpack_public_path__ + "img/5.5d534b8b.jpg";